'use strict';
import Common from '../../Utils/Common';

/**
 * @classname UndeliverableAreaError
 * @classdesc 配送不可地域エラー
 */
export default class UndeliverableAreaError {
	/**
	 * @constructor
	 * @param {jQuery} $e - body.page-order .undeliverableArea
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		if($e.val() === '1'){
			if(!$('#modal-error')[0]){
				Common.showErrorModal('ご指定の地域は配送不可地域のため、<br>お届けできません。');
			}
			$('.p-postal-code').each((idx, e) => {
				const $e = $(e);
				if($e.attr('name') !== 'customer_postal_code'){
					const postalCode = $e.val().replace('-', '');
					if(this.checkUndeliverableArea(postalCode) === true){
						$e.addClass('is-invalid').closest('.form-group__content').find('.error-tip').addClass('show').find('.error-tip__inner').html('<p>この郵便番号の地域へは配送ができません。</p>')
					}
				}
			});
		}
	};


	/**
	 * 配送不可地域確認
	 *
	 * @memberof UndeliverableAreaError
	 * @param {string} postalCode - 郵便番号
	 * @return {boolean}
	 */
	checkUndeliverableArea(postalCode) {
		console.log(`${this.constructor.name}.checkUndeliverableArea`);
		const undeliverableArea = [
			"0431400",
			"0431401",
			"0431402",
			"0431403",
			"0431404",
			"0431405",
			"0431406",
			"0431521",
			"0431522",
			"0431523",
			"0431524",
			"0431525",
			"0783871",
			"0783951",
			"0783952",
			"0783953",
			"0783954",
			"0783955",
			"0881103",
			"0970100",
			"0970101",
			"0970211",
			"0970311",
			"0970400",
			"0970401",
			"0971111",
			"0971200",
			"0971201",
			"0971202",
			"9980281",
			"9850191",
			"9850192",
			"9850193",
			"9850194",
			"9850195",
			"9860023",
			"9862211",
			"9862212",
			"9862523",
			"9862525",
			"9862526",
			"9880601",
			"9880602",
			"9880603",
			"9880604",
			"9880605",
			"9880606",
			"9880607",
			"9880611",
			"9880612",
			"9880613",
			"9880621",
			"9880622",
			"9880623",
			"9880631",
			"9880632",
			"9880633",
			"9880634",
			"1000100",
			"1000101",
			"1000102",
			"1000103",
			"1000104",
			"1000211",
			"1000212",
			"1000301",
			"1000400",
			"1000401",
			"1000402",
			"1000511",
			"1000601",
			"1001100",
			"1001101",
			"1001102",
			"1001103",
			"1001211",
			"1001212",
			"1001213",
			"1001301",
			"1001400",
			"1001401",
			"1001511",
			"1001621",
			"1001622",
			"1001623",
			"1001701",
			"1002100",
			"1002101",
			"1002211",
			"9520000",
			"9520001",
			"9520002",
			"9520003",
			"9520004",
			"9520005",
			"9520006",
			"9520007",
			"9520011",
			"9520012",
			"9520013",
			"9520014",
			"9520015",
			"9520016",
			"9520021",
			"9520022",
			"9520023",
			"9520024",
			"9520025",
			"9520026",
			"9520027",
			"9520028",
			"9520101",
			"9520102",
			"9520103",
			"9520104",
			"9520105",
			"9520106",
			"9520107",
			"9520108",
			"9520109",
			"9520111",
			"9520112",
			"9520113",
			"9520114",
			"9520115",
			"9520116",
			"9520201",
			"9520202",
			"9520203",
			"9520204",
			"9520205",
			"9520206",
			"9520207",
			"9520211",
			"9520212",
			"9520213",
			"9520214",
			"9520215",
			"9520216",
			"9520301",
			"9520302",
			"9520303",
			"9520304",
			"9520305",
			"9520306",
			"9520307",
			"9520311",
			"9520312",
			"9520313",
			"9520314",
			"9520315",
			"9520316",
			"9520317",
			"9520318",
			"9520321",
			"9520322",
			"9520421",
			"9520422",
			"9520431",
			"9520432",
			"9520433",
			"9520434",
			"9520435",
			"9520501",
			"9520502",
			"9520503",
			"9520504",
			"9520505",
			"9520511",
			"9520512",
			"9520513",
			"9520514",
			"9520515",
			"9520601",
			"9520602",
			"9520603",
			"9520604",
			"9520605",
			"9520606",
			"9520611",
			"9520612",
			"9520613",
			"9520614",
			"9520615",
			"9520621",
			"9520622",
			"9520623",
			"9520624",
			"9520625",
			"9520626",
			"9520701",
			"9520702",
			"9520703",
			"9520704",
			"9520705",
			"9520706",
			"9520711",
			"9520712",
			"9520713",
			"9520714",
			"9520715",
			"9520716",
			"9520821",
			"9520822",
			"9520823",
			"9520824",
			"9520851",
			"9520852",
			"9520853",
			"9520854",
			"9520855",
			"9520856",
			"9520857",
			"9521201",
			"9521202",
			"9521203",
			"9521204",
			"9521205",
			"9521206",
			"9521207",
			"9521208",
			"9521209",
			"9521211",
			"9521212",
			"9521213",
			"9521301",
			"9521302",
			"9521303",
			"9521304",
			"9521305",
			"9521306",
			"9521307",
			"9521308",
			"9521311",
			"9521312",
			"9521313",
			"9521314",
			"9521315",
			"9521321",
			"9521322",
			"9521323",
			"9521324",
			"9521325",
			"9521326",
			"9521431",
			"9521432",
			"9521433",
			"9521434",
			"9521435",
			"9521501",
			"9521502",
			"9521503",
			"9521504",
			"9521505",
			"9521506",
			"9521507",
			"9521508",
			"9521511",
			"9521512",
			"9521513",
			"9521514",
			"9521515",
			"9521516",
			"9521517",
			"9521518",
			"9521521",
			"9521522",
			"9521523",
			"9521524",
			"9521525",
			"9521526",
			"9521527",
			"9521528",
			"9521531",
			"9521532",
			"9521533",
			"9521534",
			"9521535",
			"9521536",
			"9521537",
			"9521538",
			"9521539",
			"9521541",
			"9521542",
			"9521543",
			"9521544",
			"9521545",
			"9521546",
			"9521547",
			"9521548",
			"9521551",
			"9521552",
			"9521553",
			"9521554",
			"9521555",
			"9521556",
			"9521557",
			"9521558",
			"9521561",
			"9521562",
			"9521563",
			"9521564",
			"9521565",
			"9521566",
			"9521567",
			"9521568",
			"9521571",
			"9521572",
			"9521573",
			"9521574",
			"9521575",
			"9521581",
			"9521582",
			"9521583",
			"9521584",
			"9521641",
			"9521642",
			"9521643",
			"9521644",
			"9521645",
			"9521646",
			"9522131",
			"9522132",
			"9522133",
			"9522134",
			"9522135",
			"9522136",
			"9522201",
			"9522202",
			"9522203",
			"9522204",
			"9522205",
			"9522206",
			"9522211",
			"9522212",
			"9522213",
			"9522214",
			"9522215",
			"9522221",
			"9522222",
			"9522223",
			"9522224",
			"9522225",
			"9522226",
			"9523111",
			"9523112",
			"9523113",
			"9523114",
			"9523115",
			"9523116",
			"9523117",
			"9523118",
			"9523119",
			"9523201",
			"9523202",
			"9523203",
			"9523204",
			"9523205",
			"9523206",
			"9523207",
			"9523421",
			"9523422",
			"9523423",
			"9523424",
			"9523425",
			"9523431",
			"9523432",
			"9523433",
			"9523434",
			"9523435",
			"9523541",
			"9523542",
			"9523543",
			"9523544",
			"9523545",
			"9523546",
			"9580061",
			"9280072",
			"4130004",
			"4440416",
			"4703504",
			"4703505",
			"5230801",
			"5170001",
			"5170002",
			"5170003",
			"5170004",
			"5170005",
			"5170205",
			"6560961",
			"6720101",
			"6720102",
			"6720103",
			"7013203",
			"7048153",
			"7060306",
			"7140035",
			"7140036",
			"7140037",
			"7140038",
			"7140301",
			"7140302",
			"7200204",
			"7220061",
			"7222431",
			"7222432",
			"7222631",
			"7222632",
			"7222633",
			"7222641",
			"7230021",
			"7230022",
			"7250200",
			"7250231",
			"7250301",
			"7250302",
			"7250303",
			"7250401",
			"7250402",
			"7250403",
			"7340017",
			"7340101",
			"7340102",
			"7340103",
			"7340301",
			"7340302",
			"7340303",
			"7340304",
			"7390501",
			"7390502",
			"7390503",
			"7390504",
			"7390505",
			"7390506",
			"7390507",
			"7390511",
			"7390512",
			"7390513",
			"7390514",
			"7390515",
			"7390516",
			"7390517",
			"7390518",
			"7390521",
			"7390522",
			"7390523",
			"7390524",
			"7390525",
			"7390531",
			"7390532",
			"7390533",
			"7390534",
			"7390535",
			"7390536",
			"7390541",
			"7390542",
			"7390543",
			"7390550",
			"7390551",
			"7390552",
			"7390553",
			"7390554",
			"7390555",
			"7390556",
			"7390557",
			"7390558",
			"7390559",
			"7390588",
			"7390607",
			"6840100",
			"6840101",
			"6840102",
			"6840103",
			"6840104",
			"6840105",
			"6840106",
			"6840107",
			"6840211",
			"6840300",
			"6840301",
			"6840302",
			"6840303",
			"6840400",
			"6840401",
			"6840402",
			"6840403",
			"6840404",
			"6840411",
			"6840412",
			"6840413",
			"6850000",
			"6850001",
			"6850002",
			"6850003",
			"6850004",
			"6850005",
			"6850006",
			"6850007",
			"6850011",
			"6850012",
			"6850013",
			"6850014",
			"6850015",
			"6850016",
			"6850017",
			"6850021",
			"6850022",
			"6850023",
			"6850024",
			"6850025",
			"6850026",
			"6850027",
			"6850101",
			"6850102",
			"6850103",
			"6850104",
			"6850105",
			"6850106",
			"6850301",
			"6850302",
			"6850303",
			"6850304",
			"6850305",
			"6850306",
			"6850311",
			"6850312",
			"6850313",
			"6850314",
			"6850411",
			"6850412",
			"6850413",
			"6850431",
			"6850432",
			"6850433",
			"6850434",
			"6850435",
			"7400051",
			"7420041",
			"7421114",
			"7421401",
			"7421404",
			"7421516",
			"7422108",
			"7422301",
			"7422601",
			"7422801",
			"7430003",
			"7450057",
			"7470832",
			"7500095",
			"7580001",
			"7580003",
			"7580701",
			"7596542",
			"7600091",
			"7600092",
			"7613110",
			"7614100",
			"7614101",
			"7614102",
			"7614103",
			"7614104",
			"7614105",
			"7614106",
			"7614111",
			"7614112",
			"7614113",
			"7614114",
			"7614115",
			"7614121",
			"7614122",
			"7614131",
			"7614132",
			"7614133",
			"7614134",
			"7614141",
			"7614142",
			"7614143",
			"7614144",
			"7614145",
			"7614146",
			"7614151",
			"7614152",
			"7614153",
			"7614154",
			"7614155",
			"7614300",
			"7614301",
			"7614302",
			"7614303",
			"7614304",
			"7614305",
			"7614306",
			"7614307",
			"7614308",
			"7614401",
			"7614402",
			"7614403",
			"7614404",
			"7614405",
			"7614411",
			"7614412",
			"7614421",
			"7614422",
			"7614423",
			"7614424",
			"7614425",
			"7614426",
			"7614431",
			"7614432",
			"7614433",
			"7614434",
			"7614661",
			"7614662",
			"7614663",
			"7614664",
			"7620071",
			"7620072",
			"7620073",
			"7630101",
			"7630102",
			"7630103",
			"7630104",
			"7630105",
			"7630106",
			"7630107",
			"7630108",
			"7630111",
			"7630221",
			"7630222",
			"7630223",
			"7630224",
			"7630225",
			"7630226",
			"7630227",
			"7630228",
			"7630231",
			"7640040",
			"7640050",
			"7680071",
			"7691108",
			"7691109",
			"7741760",
			"7750010",
			"7750011",
			"7750012",
			"7750013",
			"7880014",
			"7880677",
			"7880678",
			"7880679",
			"7914321",
			"7914322",
			"7914323",
			"7914324",
			"7914431",
			"7914432",
			"7914501",
			"7914502",
			"7914503",
			"7914504",
			"7914505",
			"7914506",
			"7914507",
			"7914508",
			"7914509",
			"7914510",
			"7914511",
			"7918091",
			"7918092",
			"7918093",
			"7920080",
			"7920891",
			"7941101",
			"7941102",
			"7941103",
			"7941301",
			"7941302",
			"7941303",
			"7941304",
			"7941305",
			"7941306",
			"7941307",
			"7941308",
			"7941309",
			"7941401",
			"7941402",
			"7941403",
			"7941404",
			"7942101",
			"7942102",
			"7942103",
			"7942104",
			"7942110",
			"7942111",
			"7942112",
			"7942113",
			"7942114",
			"7942115",
			"7942116",
			"7942117",
			"7942118",
			"7942119",
			"7942201",
			"7942202",
			"7942203",
			"7942204",
			"7942301",
			"7942302",
			"7942303",
			"7942304",
			"7942305",
			"7942410",
			"7942500",
			"7942501",
			"7942502",
			"7942503",
			"7942504",
			"7942505",
			"7942506",
			"7942507",
			"7942508",
			"7942509",
			"7942510",
			"7942511",
			"7942512",
			"7942513",
			"7942520",
			"7942530",
			"7942540",
			"7942541",
			"7942542",
			"7942550",
			"7968060",
			"7980099",
			"7980212",
			"7983358",
			"7992121",
			"7992122",
			"7992123",
			"7992433",
			"7993470",
			"8020091",
			"8020092",
			"8113511",
			"8113701",
			"8191336",
			"8115100",
			"8115101",
			"8115102",
			"8115103",
			"8115104",
			"8115105",
			"8115106",
			"8115107",
			"8115111",
			"8115112",
			"8115113",
			"8115114",
			"8115115",
			"8115116",
			"8115117",
			"8115121",
			"8115122",
			"8115123",
			"8115124",
			"8115125",
			"8115131",
			"8115132",
			"8115133",
			"8115134",
			"8115135",
			"8115136",
			"8115141",
			"8115142",
			"8115143",
			"8115144",
			"8115151",
			"8115152",
			"8115153",
			"8115154",
			"8115155",
			"8115161",
			"8115162",
			"8115163",
			"8115201",
			"8115202",
			"8115203",
			"8115204",
			"8115211",
			"8115212",
			"8115213",
			"8115214",
			"8115215",
			"8115221",
			"8115222",
			"8115223",
			"8115224",
			"8115225",
			"8115226",
			"8115301",
			"8115311",
			"8115312",
			"8115313",
			"8115314",
			"8115315",
			"8115316",
			"8115321",
			"8115322",
			"8115323",
			"8115324",
			"8115325",
			"8115326",
			"8115461",
			"8115462",
			"8115463",
			"8115464",
			"8115465",
			"8115466",
			"8115467",
			"8115468",
			"8115501",
			"8115511",
			"8115512",
			"8115513",
			"8115521",
			"8115522",
			"8115523",
			"8115531",
			"8115532",
			"8115533",
			"8115541",
			"8115542",
			"8115543",
			"8115544",
			"8115545",
			"8115546",
			"8115551",
			"8115552",
			"8115553",
			"8115554",
			"8115555",
			"8115556",
			"8115731",
			"8115732",
			"8115733",
			"8115734",
			"8115741",
			"8115742",
			"8115743",
			"8115744",
			"8115751",
			"8115752",
			"8115753",
			"8115754",
			"8115755",
			"8115756",
			"8115757",
			"8170000",
			"8170001",
			"8170002",
			"8170003",
			"8170005",
			"8170006",
			"8170011",
			"8170012",
			"8170013",
			"8170014",
			"8170015",
			"8170016",
			"8170021",
			"8170022",
			"8170023",
			"8170024",
			"8170031",
			"8170032",
			"8170033",
			"8170034",
			"8170035",
			"8170151",
			"8170152",
			"8170153",
			"8170154",
			"8170155",
			"8170156",
			"8170157",
			"8170241",
			"8170242",
			"8170243",
			"8170244",
			"8170245",
			"8170246",
			"8170247",
			"8170248",
			"8170321",
			"8170322",
			"8170323",
			"8170324",
			"8170325",
			"8170326",
			"8170431",
			"8170432",
			"8170433",
			"8170434",
			"8170435",
			"8170511",
			"8170512",
			"8170513",
			"8170514",
			"8171101",
			"8171102",
			"8171103",
			"8171104",
			"8171105",
			"8171106",
			"8171107",
			"8171201",
			"8171202",
			"8171212",
			"8171213",
			"8171214",
			"8171223",
			"8171231",
			"8171232",
			"8171233",
			"8171234",
			"8171241",
			"8171245",
			"8171246",
			"8171251",
			"8171252",
			"8171253",
			"8171254",
			"8171255",
			"8171256",
			"8171257",
			"8171301",
			"8171302",
			"8171303",
			"8171304",
			"8171305",
			"8171306",
			"8171307",
			"8171411",
			"8171412",
			"8171413",
			"8171511",
			"8171512",
			"8171513",
			"8171521",
			"8171522",
			"8171523",
			"8171524",
			"8171525",
			"8171531",
			"8171532",
			"8171533",
			"8171601",
			"8171602",
			"8171603",
			"8171701",
			"8171702",
			"8171703",
			"8171704",
			"8171711",
			"8171712",
			"8171713",
			"8171714",
			"8171715",
			"8171721",
			"8171722",
			"8171723",
			"8171724",
			"8171725",
			"8172241",
			"8172242",
			"8172243",
			"8172331",
			"8172332",
			"8172333",
			"8511315",
			"8530000",
			"8530001",
			"8530002",
			"8530003",
			"8530004",
			"8530005",
			"8530006",
			"8530007",
			"8530011",
			"8530012",
			"8530013",
			"8530014",
			"8530015",
			"8530016",
			"8530017",
			"8530018",
			"8530021",
			"8530022",
			"8530023",
			"8530024",
			"8530025",
			"8530026",
			"8530027",
			"8530031",
			"8530032",
			"8530033",
			"8530041",
			"8530042",
			"8530043",
			"8530044",
			"8530051",
			"8530052",
			"8530053",
			"8530054",
			"8530061",
			"8530062",
			"8530063",
			"8530064",
			"8530065",
			"8530066",
			"8530201",
			"8530202",
			"8530203",
			"8530204",
			"8530205",
			"8530206",
			"8530207",
			"8530208",
			"8530211",
			"8530212",
			"8530213",
			"8530214",
			"8530215",
			"8530311",
			"8530312",
			"8530313",
			"8530411",
			"8530412",
			"8530413",
			"8530501",
			"8530502",
			"8530503",
			"8530504",
			"8530505",
			"8530506",
			"8530507",
			"8530508",
			"8530601",
			"8530602",
			"8530603",
			"8530604",
			"8530605",
			"8530606",
			"8530607",
			"8530608",
			"8530609",
			"8530611",
			"8530612",
			"8530613",
			"8530701",
			"8530702",
			"8530703",
			"8530704",
			"8530705",
			"8530706",
			"8532171",
			"8532172",
			"8532173",
			"8532174",
			"8532201",
			"8532202",
			"8532203",
			"8532204",
			"8532301",
			"8532302",
			"8532303",
			"8532304",
			"8532305",
			"8532311",
			"8532312",
			"8532313",
			"8532314",
			"8532315",
			"8532481",
			"8532482",
			"8533101",
			"8533102",
			"8533321",
			"8533322",
			"8533323",
			"8570071",
			"8572531",
			"8572532",
			"8573271",
			"8574101",
			"8574102",
			"8574103",
			"8574211",
			"8574212",
			"8574213",
			"8574214",
			"8574400",
			"8574401",
			"8574402",
			"8574404",
			"8574405",
			"8574411",
			"8574412",
			"8574413",
			"8574414",
			"8574415",
			"8574416",
			"8574511",
			"8574512",
			"8574513",
			"8574514",
			"8574601",
			"8574602",
			"8574603",
			"8574604",
			"8574700",
			"8574701",
			"8574702",
			"8574703",
			"8574704",
			"8574705",
			"8574706",
			"8574707",
			"8574708",
			"8574709",
			"8574711",
			"8574712",
			"8574811",
			"8574812",
			"8574813",
			"8574814",
			"8574815",
			"8574816",
			"8574901",
			"8574902",
			"8574903",
			"8574904",
			"8580931",
			"8594529",
			"8594301",
			"8594302",
			"8594303",
			"8594304",
			"8594305",
			"8594306",
			"8594307",
			"8594308",
			"8594309",
			"8594745",
			"8594827",
			"8595101",
			"8595801",
			"8595802",
			"8595803",
			"8595804",
			"8595805",
			"8595806",
			"8470027",
			"8470131",
			"8470306",
			"8470317",
			"8470405",
			"8470406",
			"8471524",
			"8660303",
			"8660313",
			"8660334",
			"8693711",
			"8721501",
			"8760001",
			"8760002",
			"8760003",
			"8760004",
			"8760005",
			"8760006",
			"8760007",
			"8760008",
			"8761313",
			"8792501",
			"8820096",
			"8900000",
			"8900901",
			"8900902",
			"8900903",
			"8913100",
			"8913101",
			"8913102",
			"8913103",
			"8913104",
			"8913111",
			"8913112",
			"8913113",
			"8913114",
			"8913115",
			"8913116",
			"8913117",
			"8913118",
			"8913202",
			"8913221",
			"8913222",
			"8913431",
			"8913432",
			"8913600",
			"8913601",
			"8913602",
			"8913603",
			"8913604",
			"8913605",
			"8913606",
			"8913607",
			"8913701",
			"8913702",
			"8913703",
			"8913704",
			"8913705",
			"8913706",
			"8914200",
			"8914201",
			"8914202",
			"8914203",
			"8914204",
			"8914205",
			"8914206",
			"8914207",
			"8914208",
			"8914311",
			"8914312",
			"8914401",
			"8914402",
			"8914403",
			"8914404",
			"8914405",
			"8914406",
			"8914407",
			"8914408",
			"8914409",
			"8915101",
			"8915200",
			"8915201",
			"8915202",
			"8915203",
			"8915204",
			"8915205",
			"8915301",
			"8916141",
			"8916142",
			"8916143",
			"8916144",
			"8916151",
			"8916152",
			"8916153",
			"8916154",
			"8916161",
			"8916162",
			"8916163",
			"8916164",
			"8916200",
			"8916201",
			"8916202",
			"8916203",
			"8916211",
			"8916212",
			"8916213",
			"8916214",
			"8916215",
			"8916216",
			"8916217",
			"8916221",
			"8916222",
			"8916223",
			"8916224",
			"8916225",
			"8916226",
			"8916227",
			"8916228",
			"8916229",
			"8916231",
			"8916232",
			"8916233",
			"8917100",
			"8917101",
			"8917102",
			"8917103",
			"8917104",
			"8917105",
			"8917111",
			"8917112",
			"8917113",
			"8917114",
			"8917115",
			"8917116",
			"8917421",
			"8917422",
			"8917423",
			"8917424",
			"8917425",
			"8917426",
			"8917600",
			"8917601",
			"8917602",
			"8917603",
			"8917604",
			"8917605",
			"8917611",
			"8917612",
			"8917621",
			"8917622",
			"8917623",
			"8917624",
			"8917731",
			"8918111",
			"8918112",
			"8918113",
			"8918114",
			"8918115",
			"8918116",
			"8918117",
			"8918201",
			"8918216",
			"8918221",
			"8918300",
			"8918321",
			"8918322",
			"8918323",
			"8918324",
			"8918325",
			"8918326",
			"8918327",
			"8918328",
			"8918329",
			"8919100",
			"8919101",
			"8919102",
			"8919103",
			"8919104",
			"8919111",
			"8919112",
			"8919113",
			"8919114",
			"8919115",
			"8919116",
			"8919121",
			"8919122",
			"8919123",
			"8919124",
			"8919125",
			"8919131",
			"8919132",
			"8919133",
			"8919134",
			"8919135",
			"8919136",
			"8919200",
			"8919201",
			"8919202",
			"8919203",
			"8919204",
			"8919205",
			"8919206",
			"8919207",
			"8919211",
			"8919212",
			"8919213",
			"8919214",
			"8919215",
			"8919221",
			"8919222",
			"8919223",
			"8919224",
			"8919231",
			"8919232",
			"8919233",
			"8919234",
			"8919300",
			"8919301",
			"8919302",
			"8919303",
			"8919304",
			"8919305",
			"8919306",
			"8919307",
			"8919308",
			"8919309",
			"8940000",
			"8940001",
			"8940002",
			"8940003",
			"8940004",
			"8940005",
			"8940006",
			"8940007",
			"8940008",
			"8940011",
			"8940012",
			"8940013",
			"8940014",
			"8940015",
			"8940016",
			"8940017",
			"8940021",
			"8940022",
			"8940023",
			"8940024",
			"8940025",
			"8940026",
			"8940027",
			"8940031",
			"8940032",
			"8940033",
			"8940034",
			"8940035",
			"8940036",
			"8940041",
			"8940042",
			"8940043",
			"8940044",
			"8940045",
			"8940046",
			"8940047",
			"8940048",
			"8940061",
			"8940062",
			"8940063",
			"8940068",
			"8940100",
			"8940101",
			"8940102",
			"8940103",
			"8940104",
			"8940105",
			"8940106",
			"8940107",
			"8940108",
			"8940321",
			"8940322",
			"8940323",
			"8940324",
			"8940331",
			"8940332",
			"8940333",
			"8940351",
			"8940352",
			"8940411",
			"8940412",
			"8940501",
			"8940502",
			"8940503",
			"8940504",
			"8940505",
			"8940506",
			"8940507",
			"8940508",
			"8940511",
			"8940512",
			"8940513",
			"8940621",
			"8940622",
			"8940623",
			"8940624",
			"8940625",
			"8940626",
			"8940627",
			"8940771",
			"8940772",
			"8940773",
			"8940774",
			"8940775",
			"8940776",
			"8941111",
			"8941112",
			"8941113",
			"8941114",
			"8941115",
			"8941116",
			"8941201",
			"8941202",
			"8941203",
			"8941204",
			"8941205",
			"8941304",
			"8941321",
			"8941500",
			"8941501",
			"8941502",
			"8941503",
			"8941504",
			"8941505",
			"8941506",
			"8941507",
			"8941508",
			"8941509",
			"8941510",
			"8941511",
			"8941512",
			"8941513",
			"8941514",
			"8941515",
			"8941521",
			"8941522",
			"8941523",
			"8941524",
			"8941531",
			"8941741",
			"8941742",
			"8941743",
			"8941744",
			"8941745",
			"8941746",
			"8941851",
			"8941852",
			"8941853",
			"8941854",
			"8941855",
			"8942141",
			"8942142",
			"8942143",
			"8942144",
			"8942231",
			"8942232",
			"8942233",
			"8942234",
			"8942235",
			"8942236",
			"8942237",
			"8942321",
			"8942322",
			"8942323",
			"8942401",
			"8942402",
			"8942403",
			"8942404",
			"8942411",
			"8942412",
			"8942413",
			"8942414",
			"8942415",
			"8942416",
			"8942417",
			"8942501",
			"8942502",
			"8942601",
			"8943100",
			"8943101",
			"8943102",
			"8943103",
			"8943104",
			"8943105",
			"8943106",
			"8943107",
			"8943211",
			"8943212",
			"8943213",
			"8943214",
			"8943300",
			"8943301",
			"8943302",
			"8943303",
			"8943304",
			"8943305",
			"8943411",
			"8943412",
			"8943413",
			"8943521",
			"8943522",
			"8943523",
			"8943631",
			"8943632",
			"8943633",
			"8961101",
			"8961201",
			"8961202",
			"8961203",
			"8961204",
			"8961205",
			"8961206",
			"8961281",
			"8961301",
			"8961411",
			"8961412",
			"8961512",
			"8961521",
			"8961601",
			"8961602",
			"8991501",
			"9011501",
			"9013100",
			"9013101",
			"9013102",
			"9013103",
			"9013104",
			"9013105",
			"9013106",
			"9013107",
			"9013108",
			"9013111",
			"9013112",
			"9013113",
			"9013114",
			"9013115",
			"9013121",
			"9013122",
			"9013123",
			"9013124",
			"9013125",
			"9013131",
			"9013132",
			"9013133",
			"9013134",
			"9013135",
			"9013136",
			"9013137",
			"9013138",
			"9013311",
			"9013312",
			"9013400",
			"9013401",
			"9013402",
			"9013403",
			"9013500",
			"9013501",
			"9013502",
			"9013601",
			"9013700",
			"9013701",
			"9013702",
			"9013703",
			"9013800",
			"9013801",
			"9013802",
			"9013803",
			"9013804",
			"9013805",
			"9013806",
			"9013900",
			"9013901",
			"9013902",
			"9013903",
			"9042315",
			"9042316",
			"9042317",
			"9042421",
			"9042422",
			"9042423",
			"9042424",
			"9042425",
			"9042426",
			"9042427",
			"9042428",
			"9050500",
			"9050501",
			"9050502",
			"9050503",
			"9050504",
			"9050505",
			"9050600",
			"9050601",
			"9050602",
			"9050603",
			"9050604",
			"9050605",
			"9050700",
			"9050701",
			"9050702",
			"9050703",
			"9050704",
			"9050705",
			"9060000",
			"9060001",
			"9060002",
			"9060003",
			"9060004",
			"9060005",
			"9060006",
			"9060007",
			"9060008",
			"9060011",
			"9060012",
			"9060013",
			"9060014",
			"9060015",
			"9060101",
			"9060102",
			"9060103",
			"9060104",
			"9060105",
			"9060106",
			"9060107",
			"9060108",
			"9060109",
			"9060201",
			"9060202",
			"9060203",
			"9060204",
			"9060301",
			"9060302",
			"9060303",
			"9060304",
			"9060305",
			"9060306",
			"9060421",
			"9060422",
			"9060501",
			"9060502",
			"9060503",
			"9060504",
			"9060505",
			"9060506",
			"9060507",
			"9060600",
			"9060601",
			"9060602",
			"9060603",
			"9070000",
			"9070001",
			"9070002",
			"9070003",
			"9070004",
			"9070011",
			"9070012",
			"9070013",
			"9070014",
			"9070021",
			"9070022",
			"9070023",
			"9070024",
			"9070241",
			"9070242",
			"9070243",
			"9070331",
			"9070332",
			"9070333",
			"9070451",
			"9070452",
			"9070453",
			"9071101",
			"9071221",
			"9071311",
			"9071431",
			"9071432",
			"9071433",
			"9071434",
			"9071435",
			"9071541",
			"9071542",
			"9071543",
			"9071544",
			"9071751",
			"9071800",
			"9071801",
		];
		return undeliverableArea.includes(postalCode);
	};
};
